/* ============================================================
   Статья (детальная страница новости) + «другие новости».
   ============================================================ */
import { useEffect } from 'react';
import { useFedStore, useL } from '../store';
import { useFedContent, isPublished, uploadUrl } from '../content';
import { cover, SOCIALS } from '../data';
import { Ic } from '../icons';
import { Rv } from '../ui';

export default function FedArticle() {
  const { go, lang, articleId } = useFedStore();
  const L = useL();
  const news = useFedContent((s) => s.news);

  const art = news.find((n) => n.id === articleId) || news[0];
  const body = art['body_' + lang] || art.body_ru || [];
  const read = Math.max(2, Math.round(body.join(' ').length / 600));
  const related = news.filter((n) => n.id !== art.id && isPublished(n)).slice(0, 3);

  useEffect(() => { window.scrollTo(0, 0); }, [articleId]);

  return (
    <div className="fed-pagewrap max-w-[820px] mx-auto" style={{ padding: '28px 24px 72px' }}>
      <button
        onClick={() => go('news')}
        className="bg-transparent border-none cursor-pointer text-fg-muted font-display font-semibold uppercase hover:text-fg"
        style={{ fontSize: 14, letterSpacing: '.04em', padding: '6px 0' }}
      >
        {L.art_back}
      </button>

      <Rv className="flex items-center gap-2.5 flex-wrap" style={{ margin: '18px 0 16px' }}>
        <span className="rounded-full font-mono uppercase text-accent-bright" style={{ padding: '5px 12px', fontSize: 11, letterSpacing: '.1em', background: 'rgba(225,18,23,.1)', border: '1px solid var(--fed-line-accent)' }}>
          {art['cat_' + lang]}
        </span>
        <span className="font-mono text-fg-muted" style={{ fontSize: 12 }}>{art.date}</span>
        <span className="text-fg-faint">·</span>
        <span className="font-mono text-fg-muted" style={{ fontSize: 12 }}>{read} {L.art_read}</span>
      </Rv>

      <Rv as="h1" className="font-body font-extrabold text-fg" style={{ textTransform: 'none', letterSpacing: '-.01em', lineHeight: 1.15, fontSize: 'clamp(28px,4.6vw,46px)' }}>
        {art['title_' + lang]}
      </Rv>

      {/* обложка */}
      <Rv className="relative overflow-hidden rounded-[18px] shadow-card" style={{ height: 'clamp(200px,42vw,340px)', margin: '24px 0', background: cover(art.hue, 24, 10) }}>
        {art.cover
          ? <img src={uploadUrl(art.cover)} alt="" className="absolute inset-0 w-full h-full" style={{ objectFit: 'cover' }} />
          : <>
              <div className="fed-grid-tex-light" style={{ backgroundSize: '26px 26px' }} />
              <div className="absolute pointer-events-none" style={{ top: 0, bottom: 0, width: '36%', left: 0, background: 'linear-gradient(105deg,transparent,rgba(255,255,255,.07) 50%,transparent)', animation: 'fedShine 6s var(--fed-ease) 1s infinite' }} />
              <img src="/assets/logo-federation.png" alt="" className="absolute rounded-full object-cover" style={{ right: 22, bottom: 20, width: 54, height: 54, opacity: 0.9, border: '1.5px solid rgba(255,255,255,.2)' }} />
            </>}
      </Rv>

      <Rv as="p" className="text-fg-soft font-semibold" style={{ fontSize: 18, lineHeight: 1.6, marginBottom: 22 }}>
        {art['ex_' + lang]}
      </Rv>
      {body.map((para, i) => (
        <Rv as="p" key={i} className="text-fg-soft" style={{ fontSize: 16, lineHeight: 1.78, marginBottom: 18 }}>
          {para}
        </Rv>
      ))}

      {/* поделиться */}
      <Rv className="flex items-center gap-3 flex-wrap border-t border-line" style={{ marginTop: 30, paddingTop: 22 }}>
        <span className="font-mono uppercase text-fg-muted" style={{ fontSize: 11, letterSpacing: '.16em' }}>{L.art_share}</span>
        <div className="flex gap-[9px]">
          {SOCIALS.map((s) => (
            <a
              key={s.name}
              href={s.href}
              target="_blank"
              rel="noopener noreferrer"
              title={s.name}
              className="w-10 h-10 rounded-[10px] flex items-center justify-center bg-surface-2 border border-line text-fg-soft transition-colors hover:!text-accent-bright hover:border-line-accent"
            >
              <Ic name={s.icon} size={20} />
            </a>
          ))}
        </div>
      </Rv>

      {/* другие новости */}
      <div style={{ marginTop: 48 }}>
        <Rv as="h2" style={{ fontSize: 'clamp(24px,3.2vw,32px)', marginBottom: 20 }}>{L.art_related}</Rv>
        <div className="grid gap-4" style={{ gridTemplateColumns: 'repeat(auto-fit,minmax(230px,1fr))' }}>
          {related.map((n, i) => (
            <Rv
              key={n.id}
              delay={i * 0.07}
              onClick={() => go('article', { articleId: n.id })}
              className="fed-hover-lift cursor-pointer overflow-hidden rounded-[14px] bg-surface border border-line"
            >
              <div className="relative overflow-hidden" style={{ height: 110, background: cover(n.hue) }}>
                {n.cover && <img src={uploadUrl(n.cover)} alt="" className="absolute inset-0 w-full h-full" style={{ objectFit: 'cover' }} />}
                <span className="absolute font-mono uppercase text-gold rounded-md" style={{ top: 10, left: 10, padding: '4px 9px', fontSize: 9.5, letterSpacing: '.1em', background: 'rgba(6,6,8,.7)', backdropFilter: 'blur(6px)' }}>
                  {n['cat_' + lang]}
                </span>
              </div>
              <div style={{ padding: 15 }}>
                <div className="font-mono text-fg-faint" style={{ fontSize: 10.5, marginBottom: 7 }}>{n.date}</div>
                <h3 className="font-body font-extrabold text-fg" style={{ fontSize: 15, lineHeight: 1.32, textTransform: 'none', letterSpacing: 0 }}>{n['title_' + lang]}</h3>
              </div>
            </Rv>
          ))}
        </div>
      </div>
    </div>
  );
}
